import { render, staticRenderFns } from "./ComponentOverviewExport.vue?vue&type=template&id=10853f68"
import script from "./ComponentOverviewExport.vue?vue&type=script&lang=js"
export * from "./ComponentOverviewExport.vue?vue&type=script&lang=js"
import style0 from "./ComponentOverviewExport.vue?vue&type=style&index=0&id=10853f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports